import { z } from 'zod';

import { RpeCategory } from './rpe-category';
import { rpeOptionSchema } from './rpe-option';

export type RpeQuestionId = RpeQuestion['id'];

export type RpeQuestion = z.output<typeof rpeQuestionSchema>;
export type RpeQuestionDTO = z.input<typeof rpeQuestionSchema>;

export const rpeQuestionSchema = z.object({
  id: z.string(),
  title: z.string(),
  description: z.string(),
  category: z.enum(RpeCategory),
  options: z.array(rpeOptionSchema),
  minLabel: z.string().optional(),
  maxLabel: z.string().optional(),
});
